import { ContentStat } from "seneca-common/features/stats/state";
import { chooseMFromN } from "seneca-common/utils/functions";

import { GenerateContentOptions } from "../../types";
import { Content, ContentSource } from "../types";

export function generateContent(
  source: ContentSource,
  { testingActive, maxDifficulty }: GenerateContentOptions,
  contentStat?: ContentStat
): Content {
  if (!testingActive) return source as unknown as Content;

  const testedLabels = copyLabels(source.labels.filter(l => !l.nonTested));
  const toTest = getNumberToTest(
    contentStat,
    testedLabels.length,
    maxDifficulty
  );
  const testedLabelIndexes = chooseMFromN(toTest, testedLabels.length);

  testedLabelIndexes.forEach(index => {
    testedLabels[index].word.testing = true;
  });

  const nonTestedLabels = copyLabels(source.labels.filter(l => l.nonTested));
  return { ...source, labels: testedLabels.concat(nonTestedLabels) };
}

function getNumberToTest(
  meta: ContentStat | null | undefined,
  labels: number,
  maxDifficulty: boolean | null | undefined
): number {
  if (maxDifficulty) return labels;

  let maxTested;
  const deduction =
    meta && meta.lastScore !== null && meta.lastScore! < 1 ? 1 : 0;

  if (!meta || meta.timesStudied < 2) {
    maxTested = 1;
  } else if (meta.timesStudied < 4) {
    maxTested = 2;
  } else if (meta.timesStudied < 6) {
    maxTested = 3;
  } else {
    maxTested = 4;
  }

  maxTested = Math.min(maxTested, labels);

  return Math.max(1, maxTested - deduction);
}

function copyLabels(sourceLabels: any) {
  let newLabels: any[] = [];

  for (let i = 0; i < sourceLabels.length; i++) {
    newLabels[i] = { ...sourceLabels[i], word: { ...sourceLabels[i].word } };
  }

  return newLabels;
}
